import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserInterface } from 'app/models/user.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { UserDataTransformPost } from './data-transforms/user.data.transform.post';
import { UserDataTransformGet } from './data-transforms/user.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class UserHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/users(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformDown: UserDataTransformPost,
    private readonly _transformUp: UserDataTransformGet,
  ) {}

  intercept(req: HttpRequest<UserInterface>, next: HttpHandler): Observable<HttpEvent<UserInterface>> {
    return RequestService.getTransformedHttpEvent<UserInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
